import {
  FormPerformanceStep,
  FormRegistrationPerformance
} from '@features/forms/types';
import { FormOverviewConversionBreakdownApi } from '@features/forms/types/formOverviewApi';

const toPercentOfViews = (count: number, viewCount: number): number => {
  if (viewCount <= 0) return 0;
  return Math.round((count / viewCount) * 1000) / 10;
};

const toStep = (count: number, viewCount: number): FormPerformanceStep => ({
  count,
  percentOfViews: toPercentOfViews(count, viewCount)
});

export const mapRegistrationPerformance = (
  breakdown: FormOverviewConversionBreakdownApi | undefined
): FormRegistrationPerformance => {
  const viewCount = breakdown?.viewed_count ?? 0;

  return {
    views: {
      count: viewCount,
      percentOfViews: viewCount > 0 ? 100 : 0
    },
    formSubmitted: toStep(breakdown?.form_submitted_count ?? 0, viewCount),
    mobileVerified: toStep(breakdown?.mobile_verified_count ?? 0, viewCount),
    paid: toStep(breakdown?.paid_count ?? 0, viewCount)
  };
};

export default mapRegistrationPerformance;
